import { Button } from '@mui/material';
import FormProvider from '@Components/hook-form';

import { AtLocator } from '@Components/shared/locators/AtLocator';

import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { useCreateRaindropForm } from '@Forms/raindrop/CreateRaindropFormContext';

import { useCreateRaindrop } from '@Modal/hooks/raindrop/useCreateRaindrop';
import { CreateRaindropContent } from './CreateRaindropContent';

export const CreateRaindropForm = () => {
  const methods = useCreateRaindropForm();
  const { handleCreateCancel, submittable, handleSubmitCreateRaindrop } = useCreateRaindrop();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <CreateRaindropContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button variant="outlined" color="inherit" onClick={handleCreateCancel}>
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              type="button"
              variant="contained"
              disabled={!submittable}
              onClick={handleSubmitCreateRaindrop}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
